module.exports = __webpack_public_path__ + "img/5.1e2e1229.jpg";